import { ExclamationCircleOutlined } from "@ant-design/icons";
import { notification } from "antd";
import type React from "react";
import { useEffect } from "react";
import type { EHRTransferStatus } from "../../types/index.type";
import { useTransfer } from "./TransferContext";

// Show the persistent notification during active pre-awaiting_appointment states.
// Once the appointment/note-type selection modal opens (awaiting_appointment),
// the modal itself communicates urgency so the notification is hidden.
const NOTIFICATION_STATUSES: EHRTransferStatus[] = ["pending", "logging_in", "awaiting_mfa", "patient_lookup"];

const NOTIFICATION_KEY = "ehr-transfer-in-progress";

const TransferStatusBanner: React.FC = () => {
  const { currentStatus } = useTransfer();

  useEffect(() => {
    if (NOTIFICATION_STATUSES.includes(currentStatus)) {
      notification.warning({
        key: NOTIFICATION_KEY,
        message: "Transfer in progress — please stay on this page",
        description:
          "Your note is being transferred to the EHR. You may be asked to select an appointment or note template in a moment. Navigating away may cause the transfer to fail.",
        icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
        placement: "topRight",
        duration: 0, // Persistent — don't auto-close
        closable: false, // User cannot dismiss manually
      });
    } else {
      notification.destroy(NOTIFICATION_KEY);
    }

    // Cleanup on unmount (e.g., user navigates away)
    return () => {
      notification.destroy(NOTIFICATION_KEY);
    };
  }, [currentStatus]);

  return null;
};

export default TransferStatusBanner;
